import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-revenue-chart',
  templateUrl: './revenue-chart.component.html',
  styleUrls: ['../common-dashboard/common-dashboard.component.scss']
})
export class RevenueChartComponent {
  @Input() revenueData: any;
  @Input() chartOptionsForGraph: any;
}
